/**
 * Signaux de facilité (règle du projet : le jeu ne doit pas être trop simple).
 *
 * Aucun n'est une faute : chacun désigne un indice que le joueur pourrait
 * prendre pour la réponse elle-même. La machine ne sait pas décider s'il est
 * révélateur ; elle le montre, et le rédacteur confirme l'avoir vu.
 *
 * Utilisé par la barrière des révisions (`scripts/revisions.ts`) et par le site
 * d'administration. La base en rejoue la même détection
 * (`signaux_de_facilite`, supabase/migrations/0007_corpus.sql) ; un test
 * vérifie que les deux s'accordent sur tout le corpus.
 */

export type EaseSignalCode = "nombre" | "citation" | "exemple";

export type EaseSignal = {
  readonly code: EaseSignalCode;
  readonly message: string;
};

// En chiffres comme en lettres : « quatre pattes » livre autant que « 4 pattes ».
const NOMBRE = /\d|\b(deux|trois|quatre|cinq|six|sept|huit|dix|douze|vingt|cent|mille)\b/iu;
const CITATION = /[«"“]/;
const EXEMPLE = /\b(comme|par exemple|tel que|telle que)\b/iu;

export function easeSignals(definition: string): EaseSignal[] {
  const signals: EaseSignal[] = [];
  if (NOMBRE.test(definition)) {
    signals.push({
      code: "nombre",
      message: "contient un nombre — souvent la réponse presque dite (« 365 jours », « quatre pattes »)",
    });
  }
  if (CITATION.test(definition)) {
    signals.push({
      code: "citation",
      message: "contient une expression citée — souvent la collocation qui livre le mot",
    });
  }
  if (EXEMPLE.test(definition)) {
    signals.push({ code: "exemple", message: "donne un exemple — l'indice le plus facile d'une définition" });
  }
  return signals;
}
